/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Suggest_HintInputs */

const en_us2_community_suggest_hint = /** @type {(inputs: Community_Suggest_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us what the app is missing`)
};

const pt_br2_community_suggest_hint = /** @type {(inputs: Community_Suggest_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte o que faz falta no app`)
};

const es_419_community_suggest_hint = /** @type {(inputs: Community_Suggest_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuéntanos qué le falta a la app`)
};

const pt_pt2_community_suggest_hint = /** @type {(inputs: Community_Suggest_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diz-nos o que falta na app`)
};

const fr_fr2_community_suggest_hint = /** @type {(inputs: Community_Suggest_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dis-nous ce qui manque à l'appli`)
};

const de_de2_community_suggest_hint = /** @type {(inputs: Community_Suggest_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sag uns, was der App fehlt`)
};

const it_it2_community_suggest_hint = /** @type {(inputs: Community_Suggest_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dicci cosa manca nell'app`)
};

/**
* | output |
* | --- |
* | "Tell us what the app is missing" |
*
* @param {Community_Suggest_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_suggest_hint = /** @type {((inputs?: Community_Suggest_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Suggest_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_suggest_hint(inputs)
	if (locale === "es-419") return es_419_community_suggest_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_community_suggest_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_community_suggest_hint(inputs)
	if (locale === "de-DE") return de_de2_community_suggest_hint(inputs)
	if (locale === "it-IT") return it_it2_community_suggest_hint(inputs)
	return en_us2_community_suggest_hint(inputs)
});
export { community_suggest_hint as "community.suggest_hint" }